import { Timestamp } from "firebase/firestore";

interface CompetitionPricingData {
  earlyDeadline: Timestamp;
  midDeadline: Timestamp;
  earlyPrice: number;
  midPrice: number;
  latePrice: number;
}

export function calculatePrice(
  competition: CompetitionPricingData,
  today: Date = new Date()
): number {
  const earlyDeadline = competition.earlyDeadline.toDate();
  const midDeadline = competition.midDeadline.toDate();

  if (today <= earlyDeadline) {
    return competition.earlyPrice;
  } else if (today <= midDeadline) {
    return competition.midPrice;
  } else {
    return competition.latePrice;
  }
}